const topics = [
  { label: '蜜桃视频精选', hot: true, count: '2.8k' },
  { label: '红桃视频专题', hot: true, count: '1.9k' },
  { label: '香蕉视频VIP免费', hot: true, count: '3.5k' },
  { label: '樱花视频新番', hot: false, count: '1.2k' },
  { label: '每日排行榜', hot: true, count: '4.1k' },
  { label: '独家策划', hot: false, count: '986' },
  { label: '高清专区', hot: false, count: '1.5k' },
  { label: '热门合辑', hot: true, count: '2.3k' },
  { label: '编辑推荐', hot: false, count: '876' },
  { label: '最新上映', hot: true, count: '5.2k' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-18 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-12">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-100 font-heading mb-3">
            热门话题
          </h2>
          <p className="text-sm text-foreground-500 max-w-[480px] mx-auto">
            全站最受关注的热门话题标签，快速发现大家都在看什么
          </p>
        </div>
        <div className="flex flex-wrap justify-center gap-3 md:gap-4">
          {topics.map((topic) => (
            <a
              key={topic.label}
              href="#cards"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className={`group inline-flex items-center gap-2 px-4 py-2.5 rounded-full border text-sm font-medium transition-all duration-200 cursor-pointer whitespace-nowrap ${
                topic.hot
                  ? 'bg-accent-100/10 border-accent-300/30 text-accent-300 hover:bg-accent-100/20 hover:border-accent-300/50'
                  : 'bg-background-200/70 border-background-300/40 text-foreground-400 hover:bg-background-300/60 hover:text-foreground-200'
              }`}
            >
              {topic.hot && (
                <i className="ri-fire-line text-xs text-accent-400"></i>
              )}
              <span>{topic.label}</span>
              <span className="text-xs opacity-60 ml-1">{topic.count}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}